// Contracts straight from qr-lead-ui-integration.md — the QR lead campaign
// feature ("Get Leads on the Go" on the CRM home page).

export type LeadQrActionType = "whatsapp" | "call" | "email" | "rcs";
export type LeadQrFieldType = "text" | "email" | "tel" | "textarea";
export type LeadQrFont = "sans" | "serif" | "rounded";
export type LeadQrModuleStyle = "square" | "liquid";
export type LeadQrSize = 240 | 360 | 520;

export type LeadQrFormField = {
  key: string;
  label: string;
  type: LeadQrFieldType;
  required: boolean;
  placeholder?: string | null;
};

export type LeadQrFormStyle = {
  font: LeadQrFont;
  background_color: string;
  primary_color: string;
};

export type LeadQrStyle = {
  foreground_color: string;
  background_color: string;
  style: LeadQrModuleStyle;
  border: boolean;
  size: LeadQrSize;
};

export type LeadQrCampaignInput = {
  whatsapp_account_id?: string | null;
  name: string;
  page_title: string;
  page_description?: string | null;
  message_template: string;
  action_type: LeadQrActionType;
  action_target?: string | null;
  action_subject?: string | null;
  form_fields: LeadQrFormField[];
  form_style: LeadQrFormStyle;
  qr_style: LeadQrStyle;
};

export type LeadQrCampaign = LeadQrCampaignInput & {
  id: string;
  status: "active" | "disabled";
  form_url: string;
  qr_image_url: string;
  created_at: string;
  updated_at: string;
};

// The doc's recommended default — used only to seed a brand-new campaign the
// first time a business saves the Customise Lead Form modal.
export const defaultLeadQrCampaign: LeadQrCampaignInput = {
  whatsapp_account_id: null,
  name: "Lead form QR",
  page_title: "Let's start a conversation",
  page_description: "Leave the details you are comfortable sharing, then choose how to reach us.",
  message_template: "Hi, I am {first_name}. I would like to learn more.",
  action_type: "whatsapp",
  action_target: null,
  action_subject: null,
  form_fields: [
    { key: "first_name", label: "First Name", type: "text", required: true, placeholder: "Enter First Name" },
    { key: "last_name", label: "Last Name", type: "text", required: false, placeholder: "Enter Last Name" },
    { key: "phone", label: "Phone/ WhatsApp", type: "tel", required: true, placeholder: "" },
    { key: "company_name", label: "Company Name", type: "text", required: false, placeholder: "" },
    { key: "company_website", label: "Company Website", type: "text", required: false, placeholder: "" },
    { key: "role", label: "Role", type: "text", required: false, placeholder: "What's your role? e.g. Product Manager" },
    { key: "email", label: "Email Address", type: "email", required: false, placeholder: "" },
  ],
  form_style: {
    font: "sans",
    background_color: "#f8fafc",
    primary_color: "#2563eb",
  },
  qr_style: {
    foreground_color: "#000000",
    background_color: "#ffffff",
    style: "square",
    border: false,
    size: 360,
  },
};
